// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';

import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getFundsAveraging = (policyId: string) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  return backendAxios.get(`/policies/${policyId}/funds/averaging`);
};

export default getFundsAveraging;
